<template>
  <div class="container">
    <label for="invoiceStatussen" class="form-label mb-1">Filter</label>
    <div v-for="status in invoiceStatussen" :key="status.id" class="form-check form-switch">
      <input class="form-check-input"
             @change="filterStatusChanged()"
             type="checkbox"
             v-model="filter.status[status.id]"
             :id="status.id">
      <label class="form-check-label label-text" :for="`status_${status.id}`">
        &nbsp;<i class="bi bi-circle-fill close" :class="getColor(status.id)"></i>&nbsp;{{ status.label }}
      </label>
    </div>

    <div>
      <div class="mt-3">
        <div class="align-items-start">
          <label for="startDate" class="form-label">Verwerkt (Startdatum)</label>
          <input type="datetime-local" id="startDate" class="form-control" v-model="filter.startDate"
                 @change="filterStatusChanged"/>

          <label for="endDate" class="form-label">Verwerkt (Einddatum)</label>
          <input type="datetime-local" id="endDate" class="form-control" v-model="filter.endDate"
                 @change="filterStatusChanged"/>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <label for="minAmount" class="form-label">Bedrag (Min)</label>
      <input type="number" id="minAmount" class="form-control" v-model="filter.amountMin"
             @change="filterStatusChanged"/>
      <label for="maxAmount" class="form-label mt-2">Bedrag (Max)</label>
      <input type="number" id="maxAmount" class="form-control" v-model="filter.amountMax"
             @change="filterStatusChanged"/>
    </div>

    <div class="mt-3">
      <label for="invoiceDateStart" class="form-label">Fact.datum (Startdatum)</label>
      <input type="date" id="invoiceDateStart" class="form-control" v-model="filter.invoiceDateStart"
             @change="filterStatusChanged"/>
      <label for="invoiceDateEnd" class="form-label mt-2">Fact.datum (Einddatum)</label>
      <input type="date" id="invoiceDateEnd" class="form-control" v-model="filter.invoiceDateEnd"
             @change="filterStatusChanged"/>
    </div>

    <div v-if="isAdmin">
      <hr>
      <div v-if="showAdvancedFilters">
        <div class="dropdown mt-4">
          <button class="btn btn-primary dropdown-toggle" type="button" @click="toggleDropdown()" aria-expanded="false">Selecteer klanten</button>
          <div v-if="dropdownOpen" class=" px-2">
            <form class="px-4 py-3">
              <div class="form-check mb-2" v-for="(customer, key) in customerOptions" :key="key">
                <input type="checkbox" @change="filterStatusChanged()" class="form-check-input" v-model="filter.customer[key]" :id="`dropdownCheck_${key}`">
                <label class="form-check-label ms-2" :for="`dropdownCheck_${key}`">{{ customer }}</label>
              </div>
            </form>
          </div>
        </div>
        <div>
          <p class="fs-6 text-start text-secondary"><i>{{ selectedCustomer }}</i></p>
        </div>
      </div>
    </div>
    <div>
      <button type="button" class="btn btn-secondary btn-sm mt-2 position-relative" @click="toggleAdvancedFilters">
        {{ showAdvancedFilters ? 'Verberg Meer' : 'Toon Meer' }}
        <span v-if="activeAdvancedFilters"
              class="position-absolute top-0 start-100 translate-middle py-0 px-1 bg-danger border border-light rounded-circle">
            <span class="text-white fw-bolder px-1" style="font-size: 14px; line-height: 1;">!</span>
            <span class="visually-hidden">Geavanceerde filters zijn actief</span>
          </span>
      </button>
    </div>
  </div>
</template>

<script>
import Utils from "../utils/Utils"
import { watch } from 'vue'
import ServiceFactory from '@/services/ServiceFactory'
var capitalize = require('lodash/capitalize')
import localDB from '../utils/localDB';

export default {
  name: 'FilterInvoice',
  props: {
    invoiceStatussen: Array,
    isAdmin: Boolean
  },
  emits: ['filterStatusChanged'],
  data() {
    return {
      invoiceService: null,
      filter: {
        status: {},
        customer: {},
        startDate: '',
        endDate: '',
        amountMin: null,
        amountMax: null,
        invoiceDateStart: '',
        invoiceDateEnd: '',
      },
      customerOptions: {
        sabic: 'Sabic',
        tata: 'Tata',
        esso: 'Esso',
        huntsman: 'Huntsman',
        cabot: 'Cabot',
        hadro: 'Hadro',
        weir: 'Weir',
        mccain: 'McCain',
      },
      selectedCustomer: "Geen selectie",
      dropdownOpen: false,
      showAdvancedFilters: false,
      activeAdvancedFilters: false,
    }
  },
  watch: {
    invoiceStatussen: {
      handler: function (val) {
        if (val) {
          val.forEach(status => {
            this.filter.status[`status_${status.id}`] = false;
          });
        }
      },
      deep: true
    }
  },
  methods: {
    getColor(status) {
      return Utils.getColorForInvoiceStatus(status)
    },
    filterStatusChanged() {
      this.activeAdvancedFilters = Object.values(this.filter.customer).filter(active => active).length > 0;
      this.updateSelectedCustomerString()
      this.$emit('filterStatusChanged', this.filter)
    },
    updateSelectedCustomerString() {
      this.selectedCustomer = ""
      for (let customer in this.filter.customer) {
        let customerSelected = this.filter.customer[customer]
        if (customerSelected) {
          this.selectedCustomer += `${capitalize(customer)}, `
        }
      }
      if (this.selectedCustomer.length > 0) {
        this.selectedCustomer = this.selectedCustomer.slice(0, -2)
      } else {
        this.selectedCustomer = "Geen selectie"
      }
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    toggleAdvancedFilters() {
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },
  },
  async mounted() {
    this.invoiceService = ServiceFactory.getService('InvoiceService')
    this.invoiceService.addEventListener('invoicesLoaded', () => {
      this.filterStatusChanged()
    })

    const storedFilter = await localDB.getItem('invoiceFilter')
    if (storedFilter) {
      this.filter = JSON.parse(storedFilter)
      this.updateSelectedCustomerString()
    }

    watch(() => this.filter, async (newValue) => {
      await localDB.setItem('invoiceFilter', JSON.stringify(newValue))
    }, { deep: true })
  }
}
</script>

<style scoped>
.form-check-input {
  position: relative;
  top: -2px;
}
.form-check {
  display: flex;
  align-items: center;
}
.label-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
  display: inline-block;
}
.rounded-input {
  border-radius: 8px;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
}
</style>